import { Global, css } from '@emotion/react';
import React from 'react';

import { color } from '@skippay/core/styles/variables';

function GlobalStyles(): JSX.Element {
	return (
		<Global
			styles={css`
				.react-modal-sheet-backdrop {
					border: none;
					transition: all 0.2s ease;
				}
				.react-modal-sheet-content > div {
					min-height: 100%;
					display: flex;
					flex-direction: column;
				}
				body.dark & {
					.react-modal-sheet-container {
						background-color: ${color('light-gray-100', 'dark')} !important;
					}
					.react-modal-sheet-backdrop {
						background-color: rgba(0, 0, 0, 0.3) !important;
					}
					.react-modal-sheet-drag-indicator {
						background-color: #666 !important;
					}
				}
			`}
		/>
	);
}

export default GlobalStyles;
